import React from 'react';
import moment from 'moment';
import {
  Box,
  Flex,
  Icon,
  icons,
  Stat,
  StatLabel,
  StatNumber,
  chakra as C,
} from '@tapresearch/ui/components';
import useAsset from '../hook/useAsset';

export interface FieldingStatsProps {
  firstResponse: string;
  lastResponse: string;
  completesCount: number;
  originalTotal: number;
  campaignStatus: number;
}

export function FieldingStats({
  firstResponse,
  lastResponse,
  completesCount,
  originalTotal,
  campaignStatus,
}: FieldingStatsProps) {
  const asset = useAsset();

  const firstResponseText = moment(firstResponse).format('MM/DD/YY h:mm A');

  const durationText =
    lastResponse && campaignStatus === asset.constants.STATUS_COMPLETE
      ? moment.duration(moment(lastResponse).diff(firstResponse)).humanize()
      : undefined;

  return (
    <>
      {firstResponse && (
        <Box {...styles.metric}>
          <Stat color="gray.500">
            <StatLabel mb={1} fontWeight="medium">
              Launched
            </StatLabel>
            <StatNumber {...styles.statValue}>
              {firstResponseText}
              {durationText && (
                <Flex
                  {...{
                    position: 'relative',
                    mt: 1,
                    align: 'center',
                    fontSize: 'xs',
                  }}
                >
                  <Icon color="green.600" icon={icons.fi.CheckCircle} />
                  <C.span
                    fontWeight="medium"
                    color="gray.600"
                    letterSpacing={0}
                    ml={2}
                  >
                    Completed in {durationText}
                  </C.span>
                </Flex>
              )}
            </StatNumber>
          </Stat>
        </Box>
      )}
      <Box {...styles.metric}>
        <Stat color="gray.500">
          <StatLabel mb={1} fontWeight="medium">
            Responses
          </StatLabel>
          <StatNumber {...styles.statValue}>
            {completesCount} / {originalTotal}
          </StatNumber>
        </Stat>
      </Box>
    </>
  );
}

const styles = {
  metric: {
    display: 'inline-block',
    margin: '0 1px',
    padding: '7px 20px 7px 0',
    fontWeight: 'bold',
    fontSize: 'sm',
    color: 'gray.500',
    marginRight: '25px',
    _last: {
      mr: '0',
    },
  },

  statValue: {
    fontSize: 'xl',
    fontWeight: 'normal',
    color: 'gray.700',
    letterSpacing: 'tight',
    m: 0,
  },
} as const;
